export const AbsenceReason = {
    path: '/absence_reasons',
    name: 'absence_reasons',
    component: () => import('@/views/Absence/AbsenceReason/AbsenceReasonPage.vue'),
    children: [
        {
            path: '/absence_reasons/add',
            name: 'absence_reasons.add',
            component: () => import('@/views/Absence/AbsenceReason/Form/AbsenceReasonForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/absence_reasons/edit/:id',
            name: 'absence_reasons.edit',
            component: () => import('@/views/Absence/AbsenceReason/Form/AbsenceReasonForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/absence_reasons/delete/:id',
            name: 'absence_reasons.delete',
            component: () => import('@/views/Absence/AbsenceReason/Form/AbsenceReasonForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/absence_reasons/view/:id',
            name: 'absence_reasons.view',
            component: () => import('@/views/Absence/AbsenceReason/Form/AbsenceReasonForm.vue'),
            props: {viewAction: true}
        }
    ]
}